import attributes from '../constants/attributes';
import { isNZ } from '../constants/crux';

const buildPropertyUpdateRequestBody = (props) => {
    const {
        initialValues, formValues, property, usrDetail,
        additionalFields = null,
    } = props;
    let changedFields = {};

    if (formValues.propertyType &&
        formValues.propertyType.value !== initialValues.propertyType.value) {
        changedFields = {
            propertyType: formValues.propertyType.value,
        };
    }

    attributes.forEach((attribute) => {
        const fieldValue = formValues[attribute.value];
        if (!fieldValue) return;

        const isLandArea = attribute.value === 'landArea';
        const multiplier = formValues.unit === 'ha' ? 10000 : 1;
        const processedValue = isLandArea ? Math.round(fieldValue * multiplier) : parseInt(fieldValue, 10);
        const hasChanged = processedValue !== initialValues[attribute.value];

        if (hasChanged) {
            changedFields = {
                ...changedFields,
                [attribute.value]: processedValue,
            };
        }
    });

    return {
        propertyId: property.id,
        attributes: changedFields,
        author: {
            name: usrDetail ? `${usrDetail.firstName} ${usrDetail.lastName}`.trim() : '',
            email: usrDetail ? usrDetail.emailAddress : '',
            ...isNZ ? { userName: usrDetail ? usrDetail.userName : '' } : {}
        },
        additionalDetails: {
            message: formValues.additionalDetails,
            content: additionalFields,
        },
        image: formValues.image && formValues.image.base64,
    };
};

export default {
    buildPropertyUpdateRequestBody,
};
